import { Routes } from '@angular/router';
import { unitResolver } from './core/resolvers/unit.resolver';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'units'
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/Login/login.routes').then((m) => m.routes),
  },
  {
    path: 'units',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/Login/pages/unitSelection/unit-selection.component').then(
        (m) => m.UnitSelectionComponent
      ),
  },
  {
    path: 'u/kds/:routename',
    canActivate: [authGuard],
    resolve: [unitResolver],
    loadComponent: () =>
      import('./layout/components/app-layout/app-layout.component').then(
        (m) => m.AppLayoutComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'login',
  }
];
